// src/utils/favoriteUtils.js

// Clave para almacenar los favoritos en localStorage
const FAVORITES_STORAGE_KEY = 'amber_favorite_menu_items';

/**
 * Obtiene la lista de rutas favoritas desde localStorage
 * @returns {Array} Array de rutas de elementos favoritos
 */
export const getFavorites = () => {
  try {
    const favoritesJson = localStorage.getItem(FAVORITES_STORAGE_KEY);
    return favoritesJson ? JSON.parse(favoritesJson) : [];
  } catch (error) {
    console.error('Error al leer favoritos:', error);
    return [];
  }
};

/**
 * Guarda una lista de rutas favoritas en localStorage
 * @param {Array} favorites - Array de rutas de elementos favoritos
 */
export const saveFavorites = (favorites) => {
  try {
    localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(favorites));
  } catch (error) {
    console.error('Error al guardar favoritos:', error);
  }
};

/**
 * Añade un elemento a favoritos
 * @param {string} path - Ruta del elemento a añadir
 */
export const addFavorite = (path) => {
  const currentFavorites = getFavorites();
  if (!currentFavorites.includes(path)) {
    const newFavorites = [...currentFavorites, path];
    saveFavorites(newFavorites);
    return newFavorites;
  }
  return currentFavorites;
};

/**
 * Elimina un elemento de favoritos
 * @param {string} path - Ruta del elemento a eliminar
 */
export const removeFavorite = (path) => {
  const currentFavorites = getFavorites();
  const newFavorites = currentFavorites.filter(item => item !== path);
  saveFavorites(newFavorites);
  return newFavorites;
};

/**
 * Comprueba si un elemento está en favoritos
 * @param {string} path - Ruta del elemento a comprobar
 * @returns {boolean} True si está en favoritos
 */
export const isFavorite = (path) => {
  const favorites = getFavorites();
  return favorites.includes(path);
};

/**
 * Alterna el estado de favorito de un elemento
 * @param {string} path - Ruta del elemento
 * @returns {boolean} Nuevo estado (true si fue añadido, false si fue eliminado)
 */
export const toggleFavorite = (path) => {
  if (isFavorite(path)) {
    removeFavorite(path);
    return false;
  } else {
    addFavorite(path);
    return true;
  }
};